<div class="tw-relative weeklyCard"
     [ngClass]="{
       'tw-bg-teal-100 tw-mb-4': !journeyData?.weeklyJourneyVariant?.variant2,
       'tw-bg-gray-100': journeyData?.weeklyJourneyVariant?.variant2
     }"
     [style.background]="journeyData?.weeklyJourneyVariant?.variant2 ? '#f3f4f6' : null"
>
  <!--Week Number container-->
  <div
    class="tw-font-body tw-text-200"
       [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-px-4 tw-flex tw-items-center tw-gap-1.5' : 'weekStrip tw-bg-white tw-text-center tw-m-auto tw-mb-4 tw-pt-2 tw-w-[201px]'">
    <span class="tw-flex-shrink-0">
      <span [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-uppercase tw-tracking-wider' : 'tw-capitalize'">Your Treatment</span>
      <span *ngIf="(!(journeyType === WeeklyJourneyType.WEEK_ZERO && journeyData?.weeklyJourneyVariant?.variant2) || !journeyData?.weeklyJourneyVariant?.variant2)">:</span>
    </span>
    <span [ngSwitch]="journeyType"
          class="tw-font-[700]"
          [ngClass]="journeyData?.weeklyJourneyVariant?.variant2? 'tw-tracking-wider tw-flex-shrink-0 tw-text-teal-400' : 'tw-mr-1'"
    >
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_ZERO" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-hidden' : ''">&nbsp;WEEK 0</span>
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_ONE_PART_ONE" >&nbsp;WEEK 1</span>
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_ONE_PART_TWO" >&nbsp;WEEK 1</span>
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_TWO_PART_ONE" >&nbsp;WEEK 2</span>
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_TWO_PART_TWO" >&nbsp;WEEK 2</span>
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_THREE" >&nbsp;WEEK 3</span>
      <span *ngSwitchCase="WeeklyJourneyType.WEEK_FOUR" >&nbsp;WEEK 4</span>
      <span *ngSwitchDefault >&nbsp;WEEK 1</span>
      <img *ngIf="!journeyData?.weeklyJourneyVariant?.variant2" class="tw-inline-flex tw-mb-[2px] tw-ml-1" src="/assets/icons/teal-tick-circle.svg" alt="tick"/>
    </span>

    <div *ngIf="journeyData?.weeklyJourneyVariant?.variant2" class="tw-bg-gray-300 tw-h-[2px] tw-w-full"></div>
  </div>
  <!-- Title Section with Template -->
  <div class="tw-hidden" *ngIf="!journeyData?.weeklyJourneyVariant?.variant2" [ngSwitch]="journeyType">
    <!-- Week Zero -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_ZERO">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week0',
          hasButton: true,
          buttonAction: 'trackOrder',
          ctaIdentifier: 'week_0_track_order',
          showDeliveryDate: true
        }
      }"></ng-container>
    </ng-container>

    <!-- Week One Part One -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_ONE_PART_ONE">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week1p1',
          hasButton: true,
          buttonAction: 'watchVideo',
          showDeliveryDate: false,
           ctaIdentifier: 'week_1_p1_Dr_Charu_video',
        }
      }"></ng-container>
    </ng-container>

    <!-- Week One Part Two -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_ONE_PART_TWO">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week1p2',
          hasButton: true,
          buttonAction: 'watchVideo',
          showDeliveryDate: false,
          ctaIdentifier: 'week_1_p2_Dr_Charu_video',
        }
      }"></ng-container>
    </ng-container>

    <!-- Week Two Part One -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_TWO_PART_ONE">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week2p1',
          hasButton: false,
          buttonAction: null,
          showDeliveryDate: false,
        }
      }"></ng-container>
    </ng-container>

    <!-- Week Two Part Two -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_TWO_PART_TWO">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week2p2',
          hasButton: false,
          buttonAction: null,
          showDeliveryDate: false
        }
      }"></ng-container>
    </ng-container>

    <!-- Week Three -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_THREE">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week3',
          hasButton: true,
          buttonAction: 'takeCheckup',
          showDeliveryDate: false,
          ctaIdentifier: 'week_3_checkup_header_cta',
        }
      }"></ng-container>
    </ng-container>

    <!-- Week Four -->
    <ng-container *ngSwitchCase="WeeklyJourneyType.WEEK_FOUR">
      <ng-container *ngTemplateOutlet="titleTemplate; context: {
        $implicit: {
          titleType: 'week4',
          hasButton: true,
          buttonAction: 'knowMore',
          showDeliveryDate: false,
          ctaIdentifier: 'week_4_result_timeline_header',
        }
      }"></ng-container>
    </ng-container>
  </div>
  <!-- Content Section with Switch Statement -->
  <div [ngSwitch]="journeyType">
    <!-- Week Zero Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_ZERO">
      <swiper [config]="carouselConfigWeeklyJourney"
              [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'"
      >
        <!-- Card 0 -->
        <ng-container *ngIf="journeyData?.latestPlacedRegimenOrder?.id">
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: kitImg,
              hasImage: true,
              hasCta: true,
              textContent: 'week0-card0',
              ctaContent: 'week0-card0-cta',
              ctaAction: 'trackOrder',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              ctaIdentifier: 'week_0_track_order',
            }
          }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: (journeyData?.weeklyJourneyVariant?.variant2 ?  journeyData?.allocatedDoctor?.get('DoctorImageThumbnail') : journeyData?.allocatedDoctor?.get('doctorDisplayImage')) || journeyData?.defaultDoctorImage,
              hasImage: true,
              hasCta: true,
              textContent: 'week0-card1',
              ctaContent: 'week0-card1-cta',
              ctaAction: 'doctor',
              ctaIdentifier: 'week_0_doctor',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl:  journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/faceWithProducts.png': 'https://cdn.cureskin.com/app/img/faceWithProductsCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week0-card2',
              ctaContent: 'week0-card2-cta',
              ctaAction: 'instructions',
              customCardCss: 'tw-bg-[#EEFDFF]',
              ctaIdentifier: 'week_0_instructions',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 3 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl:  journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/fruitsAndVegetables.png' : 'https://cdn.cureskin.com/app/img/broccoli-gray-bg.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week0-card3',
              ctaContent: 'week0-card3-cta',
              ctaAction: 'diet',
              customCardCss: 'tw-bg-[#FFFDE5]',
              ctaIdentifier: 'week_0_diet',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 4 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week0-card4',
              ctaContent: 'week0-card4-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_0_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>
    <!-- Week One Part One Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_ONE_PART_ONE">
      <swiper [config]="carouselConfigWeeklyJourney" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'">

        <!-- Card 0 -->
        <ng-container>
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/drCharuVideoThumbnailWithPlayRectangle.png' : 'https://cdn.cureskin.com/app/img/drCharuVideoThumbnailWithPlay.png' ,
              hasImage: true,
              hasCta: true,
              textContent: 'week1p1-card0',
              ctaContent: 'week1p1-card0-cta',
              ctaAction: 'explore',
              exploreId: 'iv6pdwK1x9',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              ctaIdentifier: 'week_1_p1_Dr_Charu_video',
            }
          }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/faceWithProducts.png' : 'https://cdn.cureskin.com/app/img/faceWithProductsCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p1-card1',
              ctaContent: 'week1p1-card1-cta',
              ctaAction: 'instructions',
              customCardCss: 'tw-bg-[#EEFDFF]',
              ctaIdentifier: 'week_1_p1_instructions',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/doctorLookingAtLaptop.png' : (journeyData?.allocatedDoctor?.get('doctorDisplayImage') || journeyData?.defaultDoctorImage),
              hasImage: true,
              hasCta: true,
              textContent: 'week1p1-card2',
              ctaContent: 'week1p1-card2-cta',
              ctaAction: 'checkup',
              ctaIdentifier: 'week_1_p1_checkup',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 3 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/faceWithSkinIssues.png' : 'https://cdn.cureskin.com/app/img/faceWithSkinIssuesCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p1-card3',
              ctaContent: 'week1p1-card3-cta',
              ctaAction: 'article',
              articleId: '68tmQuvkpb',
              customCardCss: 'tw-bg-[#FFFDE5]',
              ctaIdentifier: 'week_1_p1_reactions',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 4 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p1-card4',
              ctaContent: 'week1p1-card4-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_1_p1_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>

    <!-- Week One Part Two Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_ONE_PART_TWO">
      <swiper [config]="carouselConfigWeeklyJourney" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'">

        <!-- Card 0 -->
        <ng-container>
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/drCharuVideoThumbnailWithPlayRectangle.png' : 'https://cdn.cureskin.com/app/img/drCharuVideoThumbnailWithPlay.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p2-card0',
              ctaContent: 'week1p2-card0-cta',
              ctaAction: 'explore',
              exploreId: 'iv6pdwK1x9',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              ctaIdentifier: 'week_1_p2_Dr_Charu_video',
            }
          }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/faceWithProducts.png' : 'https://cdn.cureskin.com/app/img/faceWithProductsCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p2-card1',
              ctaContent: 'week1p2-card1-cta',
              ctaAction: 'instructions',
              customCardCss: 'tw-bg-[#EEFDFF]',
              ctaIdentifier: 'week_1_p2_instructions',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/doctorWithSkinChanges.png' : 'https://cdn.cureskin.com/app/img/dr-with-gray-bg.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p2-card2',
              ctaContent: 'week1p2-card2-cta',
              ctaAction: 'article',
              articleId: '7T2BaIQHxh',
              ctaIdentifier: 'week_1_p2_result_timeline',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 3 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/repairCreamQuantity.png' : 'https://cdn.cureskin.com/app/img/repairCreamQuantityCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p2-card3',
              ctaContent: 'week1p2-card3-cta',
              ctaAction: 'article',
              articleId: '6dH4XFVff4',
              customCardCss: 'tw-bg-[#FFFDE5]',
              ctaIdentifier: 'week_1_p2_tip_repair_cream',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 4 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week1p2-card4',
              ctaContent: 'week1p2-card4-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_1_p2_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>

    <!-- Week Two Part One Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_TWO_PART_ONE">
      <swiper [config]="carouselConfigWeeklyJourney" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'">
        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: (journeyData?.weeklyJourneyVariant?.variant2 ?  journeyData?.allocatedDoctor?.get('DoctorImageThumbnail') : journeyData?.allocatedDoctor?.get('doctorDisplayImage')) || journeyData?.defaultDoctorImage,
              hasImage: true,
              hasCta: true,
              textContent: 'week2p1-card1',
              ctaContent: 'week2p1-card1-cta',
              ctaAction: 'checkup',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              ctaIdentifier: 'week_2_p1_checkup_date',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/doctorLookingAtLaptop.png' : 'https://cdn.cureskin.com/app/img/doctorLookingAtLaptopCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week2p1-card2',
              ctaContent: 'week2p1-card2-cta',
              ctaAction: 'checkup',
              customCardCss: 'tw-bg-[#EEFDFF]',
              ctaIdentifier: 'week_2_p1_free_checkup',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 3 -->
        @if (!appConfig.Shared.isKiosk) {
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
              $implicit: {
                imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ?  'https://cdn.cureskin.com/app/img/threeFaces.png' : 'https://cdn.cureskin.com/app/img/threeFacesCropped.png',
                hasImage: true,
                hasCta: true,
                textContent: 'week2p1-card3',
                ctaContent: 'week2p1-card3-cta',
                ctaAction: 'userStories',
                customCardCss: 'tw-bg-[#FFFDE5]',
                ctaIdentifier: 'week_2_p1_testimonial',
              }
            }"></ng-container>
          </ng-container>
        }

        <!-- Card 4 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week2p1-card4',
              ctaContent: 'week2p1-card4-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_2_p1_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>

    <!-- Week Two Part Two Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_TWO_PART_TWO">
      <swiper [config]="carouselConfigWeeklyJourney" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'">
        <ng-container *ngIf="journeyData?.weeklyJourneyVariant?.variant2">
          <!-- Card 0 -->
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: (journeyData?.weeklyJourneyVariant?.variant2 ?  journeyData?.allocatedDoctor?.get('DoctorImageThumbnail') : journeyData?.allocatedDoctor?.get('doctorDisplayImage')) || journeyData?.defaultDoctorImage,
              hasImage: true,
              hasCta: true,
              textContent: 'week2p1-card1',
              ctaContent: 'week2p1-card1-cta',
              ctaAction: 'checkup',
              ctaIdentifier: 'week_2_p2_checkup',
            }
          }"></ng-container>
          </ng-container>
        </ng-container>
        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/applyingSunscreen.png': 'https://cdn.cureskin.com/app/img/applyingSunscreenCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week2p2-card1',
              ctaContent: 'week2p2-card1-cta',
              ctaAction: 'article',
              articleId: 'hUUviTYk22',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              customCardCss: 'tw-bg-[#FFFDE5]',
              ctaIdentifier: 'week_2_p2_tip_sunscreen',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/doctorWithSkinChanges.png' : 'https://cdn.cureskin.com/app/img/dr-with-gray-bg.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week2p2-card2',
              ctaContent: 'week2p2-card2-cta',
              ctaAction: 'article',
              articleId: '7T2BaIQHxh',
              ctaIdentifier: 'week_2_p2_result_timeline',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 3 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/faceWithSkinIssues.png' : 'https://cdn.cureskin.com/app/img/faceWithSkinIssuesCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week2p2-card3',
              ctaContent: 'week2p2-card3-cta',
              ctaAction: 'article',
              articleId: '68tmQuvkpb',
              customCardCss: 'tw-bg-[#FFFDE5]',
              ctaIdentifier: 'week_2_p2_reactions',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 4 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week2p2-card4',
              ctaContent: 'week2p2-card4-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_2_p2_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>

    <!-- Week Three Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_THREE">
      <swiper [config]="carouselConfigWeeklyJourney" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'">

        <ng-container *ngIf="journeyData?.weeklyJourneyVariant?.variant2">
          <!-- Card 0 -->
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: 'https://cdn.cureskin.com/app/img/takeCheckup.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week3p1-card0',
              ctaContent: 'week3p1-card0-cta',
              ctaAction: 'takePhoto',
              ctaIdentifier: 'week_3_take_photo',
            }
          }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/doctorLookingAtLaptop.png' : 'https://cdn.cureskin.com/app/img/doctorLookingAtLaptopCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week3p1-card1',
              ctaContent: 'week3p1-card1-cta',
              ctaAction: 'checkup',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              customCardCss: 'tw-bg-[#EEFDFF]',
              ctaIdentifier: 'week_3_free_checkup',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        @if (!appConfig.Shared.isKiosk) {
          <ng-container *swiperSlide>
            <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
              $implicit: {
                imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ?  'https://cdn.cureskin.com/app/img/threeFaces.png' : 'https://cdn.cureskin.com/app/img/threeFacesCropped.png',
                hasImage: true,
                hasCta: true,
                textContent: 'week3p1-card2',
                ctaContent: 'week3p1-card2-cta',
                ctaAction: 'userStories',
                customCardCss: 'tw-bg-[#FFFDE5]',
                ctaIdentifier: 'week_3_testimonial',
              }
            }"></ng-container>
          </ng-container>
        }

        <!-- Card 3 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week3p1-card3',
              ctaContent: 'week3p1-card3-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_3_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>

    <!-- Week Four Content -->
    <div *ngSwitchCase="WeeklyJourneyType.WEEK_FOUR">
      <swiper [config]="carouselConfigWeeklyJourney" [ngClass]="journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-4' : 'tw-px-6 tw-pt-14 tw-pb-11'">
        <!-- Card 1 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/skinHealingStages.png' : 'https://cdn.cureskin.com/app/img/skinHealingStagesCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week4p1-card1',
              ctaContent: 'week4p1-card1-cta',
              ctaAction: 'article',
              articleId: 'WaGYgN5j8w',
              customBorder: 'tw-bg-gradient-green-to-white tw-bg-[length:400%_100%] tw-animate-background_gradient',
              customCardCss: 'tw-bg-[#F0F8FF]',
              ctaIdentifier: 'week_4_skin_healing',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 2 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/drinkingWater.png' : 'https://cdn.cureskin.com/app/img/drinkingWaterCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week4p1-card2',
              ctaContent: 'week4p1-card2-cta',
              ctaAction: 'article',
              articleId: '6wvnoXzi2G',
              ctaIdentifier: 'week_4_drinking_water',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 3 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/fruitsAndVegetables.png' : 'https://cdn.cureskin.com/app/img/broccoli-gray-bg.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week4p1-card3',
              ctaContent: 'week4p1-card3-cta',
              ctaAction: 'diet',
              customCardCss: 'tw-bg-[#FFFDE5]',
              ctaIdentifier: 'week_4_diet',
            }
          }"></ng-container>
        </ng-container>

        <!-- Card 4 -->
        <ng-container *swiperSlide>
          <ng-container *ngTemplateOutlet="journeyCardTemplate; context: {
            $implicit: {
              imageUrl: journeyData?.weeklyJourneyVariant?.variant2 ? 'https://cdn.cureskin.com/app/img/chatIllustration.png' : 'https://cdn.cureskin.com/app/img/chatIllustrationCropped.png',
              hasImage: true,
              hasCta: true,
              textContent: 'week4p1-card4',
              ctaContent: 'week4p1-card4-cta',
              ctaAction: 'help',
              customCardCss: 'tw-bg-[#F0FFFB] tw-border tw-border-teal-400',
              ctaIdentifier: 'week_4_help',
            }
          }"></ng-container>
        </ng-container>
      </swiper>
    </div>
  </div>

  <!-- Title Template -->
  <ng-template #titleTemplate let-config>
    <div>
      <!-- Main Title Section -->
      <div class="tw-text-center tw-text-600 tw-font-body tw-font-[700] tw-mb-1 tw-m-auto tw-w-full tw-max-w-[290px]"
           [class.tw-mb-2]="config.titleType === 'week3' || config.titleType === 'week4'">

        <!-- Title Content Switch -->
        <div [ngSwitch]="config.titleType">
          <!-- Week 0 Title -->
          <div *ngSwitchCase="'week0'">
            <p i18n="@@hiUser" >Hi {{ journeyData?.user?.get("PatientName")?.split(" ")[0] }},</p>
            <p class="tw-normal-case" i18n="@@orderReceived">We have received your order</p>
          </div>

          <!-- Week 1 Part 1 Title -->
          <div *ngSwitchCase="'week1p1'">
            <p i18n="@@week1Journey"> You are in week 1 of your journey </p>
          </div>

          <!-- Week 1 Part 2 Title -->
          <div *ngSwitchCase="'week1p2'">
            <p i18n="@@week1Journey"> You are in week 1 of your journey </p>
          </div>

          <!-- Week 2 Part 1 Title -->
          <div *ngSwitchCase="'week2p1'">
            <p i18n="@@week2Journey"> You are in week 2 of your journey </p>
          </div>

          <!-- Week 2 Part 2 Title -->
          <div *ngSwitchCase="'week2p2'">
            <p i18n="@@week2Journey"> You are in week 2 of your journey </p>
          </div>

          <!-- Week 3 Title -->
          <div *ngSwitchCase="'week3'">
            <p i18n="@@monthlyCheckup">Your can now take your monthly checkup </p>
          </div>

          <!-- Week 4 Title -->
          <div *ngSwitchCase="'week4'">
            <p i18n="@@weekFourJourney">You are in week 4 of your journey</p>
          </div>
        </div>
      </div>

      <!-- Subtitle Section -->
      <div class="subTitle tw-text-center tw-mb-4 tw-font-body tw-text-300 tw-mx-4"
           [class.tw-mb-3]="config.titleType === 'week0'">

        <div [ngSwitch]="config.titleType">
          <!-- Week 0 Subtitle -->
          <div *ngSwitchCase="'week0'">
          <div *ngIf="expectedDeliveryDate" i18n="@@estimatedDelivery">Estimated delivery : {{ expectedDeliveryDate.from | date: "d MMM" }} - {{ expectedDeliveryDate.to | date: "d MMM" }}</div>
          </div>

          <!-- Week 1 Part 1 Subtitle -->
          <div *ngSwitchCase="'week1p1'" i18n="@@whatToExpectNext">
            What to expect next? <br/> - Dr. Charu
          </div>

          <!-- Week 1 Part 2 Subtitle -->
          <div *ngSwitchCase="'week1p2'" i18n="@@whatToExpectNext">
            What to expect next? <br/> - Dr. Charu
          </div>

          <!-- Week 3 Subtitle -->
          <div *ngSwitchCase="'week3'">
            <p i18n="@@checkUpExpiresOn">Checkup expires on {{ journeyData?.followUp?.get("deadline") | date: "dd MMM YYY" }}</p>
          </div>

          <!-- Week 4 Subtitle -->
          <div *ngSwitchCase="'week4'">
            <p i18n="@@useTreatmentKit">Continue using your treatment kit for the best results!</p>
          </div>
        </div>
      </div>

      <!-- Button Section -->
      <div *ngIf="config.hasButton"
           class="tw-text-center tw-mb-4 tw-mx-4"
           [class.tw-flex]="config.buttonAction === 'trackOrder'"
           [class.tw-justify-center]="config.buttonAction === 'trackOrder'"
           [class.tw-items-center]="config.buttonAction === 'trackOrder'"
           [class.tw-mb-3]="config.buttonAction === 'trackOrder'">

        <button class="tw-w-max tw-h-8 tw-pl-4 tw-pr-1 tw-items-center tw-bg-teal-600 tw-rounded-2 tw-m-auto tw-capitalize"
                (click)="handleTitleButton(config.buttonAction, config?.ctaIdentifier)"
                *ngIf="config.buttonAction !== 'trackOrder' || journeyData?.latestPlacedRegimenOrder?.get('trackingURL')">

          <span class="tw-normal-case tw-font-body tw-text-300 tw-tracking-normal tw-text-white tw-whitespace-break-spaces"
                [ngSwitch]="config.buttonAction">
            <span *ngSwitchCase="'trackOrder'" i18n="@@trackMyOrder">Track My Order</span>
            <span *ngSwitchCase="'watchVideo'" i18n="@@watchVideo">Watch Video</span>
            <span *ngSwitchCase="'knowMore'" i18n="@@knowMore">Know More</span>
            <span *ngSwitchCase="'takeCheckup'" i18n="@@takeCheckup">Take Check-up</span>
          </span>

          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'chevron_right'"></cs-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Reusable Card Template -->
  <ng-template #journeyCardTemplate let-card>
    <div class="tw-shadow-z4 tw-h-full"
         [ngClass]="
            !journeyData?.weeklyJourneyVariant?.variant2
              ? (card?.customBorder
                  ? card.customBorder + ' tw-p-0.5 tw-w-48 tw-aspect-square tw-rounded-[15px]'
                  : 'tw-bg-white tw-w-48 tw-aspect-square tw-rounded-[15px] tw-p-1')
              : (card?.customCardCss || 'tw-bg-white') + ' tw-w-32 tw-rounded-2'
          "
         (click)="handleCardCta(card.ctaAction, card.ctaIdentifier, card.articleId, card.exploreId)"
    >
      <div class="tw-w-full tw-overflow-visible tw-relative tw-grid tw-grid-cols-1 tw-justify-between"
           [ngClass]="[
              journeyData?.weeklyJourneyVariant?.variant2 ? 'tw-p-2 tw-pb-3 tw-rounded-[6px] tw-grid-rows-2 tw-gap-1 tw-h-full' : 'tw-bg-white tw-px-4 tw-aspect-square tw-rounded-[14px] tw-grid-rows-3 tw-gap-4',
            ]"
      >
        <!--V1 Image Section -->
        <div  class="tw-absolute tw-top-[-40px] tw-left-4" *ngIf="card.hasImage && !journeyData?.weeklyJourneyVariant?.variant2">
          <img [src]="card.imageUrl" [alt]="'Journey card image'" class="tw-w-20 tw-aspect-square tw-rounded-full tw-object-cover tw-object-center" />
        </div>

        <div class=" tw-w-full tw-h-[72px] tw-rounded-[6px]" *ngIf="card.hasImage && journeyData?.weeklyJourneyVariant?.variant2">
          <img *ngIf="['week_0_doctor', 'week_2_p1_checkup_date', 'week_2_p2_checkup'].includes(card.ctaIdentifier)" [src]="card.imageUrl" [alt]="'Journey card image'" class="tw-w-full tw-h-[72px] tw-rounded-[6px] tw-object-scale-down tw-object-top"/>
          <img *ngIf="!(['week_0_doctor', 'week_2_p1_checkup_date', 'week_2_p2_checkup'].includes(card.ctaIdentifier))" [src]="card.imageUrl" [alt]="'Journey card image'" class="tw-w-full tw-h-[72px] tw-rounded-[6px] tw-object-cover tw-object-top"/>
        </div>
        <div *ngIf="!journeyData?.weeklyJourneyVariant?.variant2" class="flex-1"></div>
        <!-- Text Content -->
        <div class="flex-1 tw-text-300 tw-font-medium"
             [ngClass]="{ 'tw-flex tw-items-end tw-justify-between': journeyData?.weeklyJourneyVariant?.variant2, '-tw-mt-2': !journeyData?.weeklyJourneyVariant?.variant2 }"
             [ngSwitch]="card.textContent">
          <!-- Week 0 Text Content -->
          <p *ngSwitchCase="'week0-card0'" class="tw-pr-1" i18n="@@estimatedDelivery">Estimated delivery : {{ expectedDeliveryDate.from | date: "d MMM" }} - {{ expectedDeliveryDate.to | date: "d MMM" }}</p>
          <div *ngSwitchCase="'week0-card1'">
            <p i18n="@@yourSkinSpecialistWeeklyJourney">Your skin specialist:</p>
            <p class="tw-w-[90px] tw-truncate">
              {{ journeyData?.allocatedDoctor?.get('DoctorDisplayName')?.split(' ')?.slice(0, 2).join(' ') || 'Dr. Charu' }}
            </p>
          </div>
          <p *ngSwitchCase="'week0-card2'" i18n="@@knowHowToUseOurProducts">Know how to use your products</p>
          <p *ngSwitchCase="'week0-card3'" i18n="@@yourSkinFriendlyDietIsReady">Your skin-friendly diet is ready</p>
          <p *ngSwitchCase="'week0-card4'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <!-- Week 1 Part 1 Text Content -->
          <p *ngSwitchCase="'week1p1-card0'" i18n="@@whatToExpectNext"> What to expect next? <br/> - Dr. Charu </p>
          <p *ngSwitchCase="'week1p1-card1'" i18n="@@knowHowToUseOurProducts">Know how to use your products</p>
          <p *ngSwitchCase="'week1p1-card2'" i18n="@@yourDoctorCheckupsAreFree">Your doctor checkups are free</p>
          <p *ngSwitchCase="'week1p1-card3'" i18n="@@areYouFacingSkinReactions">Are you facing skin reactions?</p>
          <p *ngSwitchCase="'week1p1-card4'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <!-- Week 1 Part 2 Text Content -->
          <p *ngSwitchCase="'week1p2-card0'" i18n="@@whatToExpectNext"> What to expect next? <br/> - Dr. Charu </p>
          <p *ngSwitchCase="'week1p2-card1'" i18n="@@knowHowToUseOurProducts">Know how to use your products</p>
          <p *ngSwitchCase="'week1p2-card2'" i18n="@@whenWillISeeChangesInMySkin">When will I see changes in my skin?</p>
          <p *ngSwitchCase="'week1p2-card3'" i18n="@@tipUseSmallAmountOfRepairCream">Tip: Use small amount of repair cream</p>
          <p *ngSwitchCase="'week1p2-card4'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <!-- Week 2 Part 1 Text Content -->
          <p *ngSwitchCase="'week2p1-card1'" i18n="@@yourFreeCheckupIsOn">Your free checkup is on {{
              journeyData?.followUp?.get("effectiveFollowUpDate") ||
              journeyData?.followUp?.get("nextFollowUpDate") | date: "dd MMM"
            }} </p>
          <p *ngSwitchCase="'week2p1-card2'" i18n="@@whatAreMonthlyCheckup" class="tw-lowercase first-letter:tw-uppercase"> What Are Free Monthly Checkups? </p>
          <p *ngSwitchCase="'week2p1-card3'" i18n="@@ninetySixPercentUsersSawFasterResults">96% saw faster results with checkups</p>
          <p *ngSwitchCase="'week2p1-card4'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <!-- Week 2 Part 2 Text Content -->
          <p *ngSwitchCase="'week2p2-card1'" i18n="@@tipResultsWithDailySunscreen">Tip: 2x results with daily sunscreen</p>
          <p *ngSwitchCase="'week2p2-card2'" i18n="@@whenWillISeeChangesInMySkin">When will I see changes in my skin?</p>
          <p *ngSwitchCase="'week2p2-card3'" i18n="@@areYouFacingSkinReactions">Are you facing skin reactions?</p>
          <p *ngSwitchCase="'week2p2-card4'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <!-- Week 3 Text Content -->
          <p *ngSwitchCase="'week3p1-card0'" i18n="@@yourFreeCheckupIsActive">Your free checkup is active</p>
          <p *ngSwitchCase="'week3p1-card1'" i18n="@@whatAreMonthlyCheckup" class="tw-lowercase first-letter:tw-uppercase"> What Are Free Monthly Checkups? </p>
          <p *ngSwitchCase="'week3p1-card2'" i18n="@@ninetySixPercentUsersSawFasterResults">96% saw faster results with checkups</p>
          <p *ngSwitchCase="'week3p1-card3'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <!-- Week 4 Text Content -->
          <p *ngSwitchCase="'week4p1-card1'" i18n="@@weekFourCardOne"> Skin healing happens in 3 stages! </p>
          <p *ngSwitchCase="'week4p1-card2'" i18n="@@howDrinkingWaterHelpsYourSkin">How drinking water helps your skin?</p>
          <p *ngSwitchCase="'week4p1-card3'" i18n="@@dietAlsoPlaysImportantRole">Diet also plays an important role</p>
          <p *ngSwitchCase="'week4p1-card4'" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</p>

          <img *ngIf="journeyData?.weeklyJourneyVariant?.variant2 && card.hasCta"  src="/assets/icons/right-chevron-teal.svg" class="tw-h-[18px] tw-w-3 tw-flex-shrink-0">

        </div>

        <!-- CTA Section -->
        <div *ngIf="!journeyData?.weeklyJourneyVariant?.variant2" class="flex-1">
          <div role="button" *ngIf="card.hasCta" class="tw-bg-white tw-text-teal-600 tw-border tw-border-teal-600 tw-pl-3 tw-pr-0 tw-py-[3px] tw-rounded-2 tw-w-max tw-flex tw-items-center tw-capitalize">
          <span class="tw-text-300 tw-font-semibold tw-font-lexend" [ngSwitch]="card.ctaContent">
            <!-- Week 0 CTA Content -->
            <span *ngSwitchCase="'week0-card0-cta'" i18n="@@trackHere">Track Here</span>
            <span *ngSwitchCase="'week0-card1-cta'" i18n="@@knowMore">Know More</span>
            <span *ngSwitchCase="'week0-card2-cta'" i18n="@@howToUse"> How to use </span>
            <span *ngSwitchCase="'week0-card3-cta'" i18n="@@checkDiet">Check diet</span>
            <span *ngSwitchCase="'week0-card4-cta'" i18n="@@takeHelp">Take help</span>

            <!-- Week 1 Part 1 CTA Content -->
            <span *ngSwitchCase="'week1p1-card0-cta'" i18n="@@watchVideo">Watch Video</span>
            <span *ngSwitchCase="'week1p1-card1-cta'" i18n="@@howToUse"> How to use </span>
            <span *ngSwitchCase="'week1p1-card2-cta'" class="tw-normal-case" i18n="@@seeCheckUps">See Check-ups</span>
            <span *ngSwitchCase="'week1p1-card3-cta'" i18n="@@readMore">Read More</span>
            <span *ngSwitchCase="'week1p1-card4-cta'" i18n="@@takeHelp">Take help</span>

            <!-- Week 1 Part 2 CTA Content -->
            <span *ngSwitchCase="'week1p2-card0-cta'" i18n="@@watchVideo">Watch Video</span>
            <span *ngSwitchCase="'week1p2-card1-cta'" i18n="@@howToUse"> How to use </span>
            <span *ngSwitchCase="'week1p2-card2-cta'" i18n="@@readMore">Read More</span>
            <span *ngSwitchCase="'week1p2-card3-cta'" i18n="@@knowMore">Know More</span>
            <span *ngSwitchCase="'week1p2-card4-cta'" i18n="@@takeHelp">Take help</span>

            <!-- Week 2 Part 1 CTA Content -->
            <span *ngSwitchCase="'week2p1-card1-cta'" class="tw-normal-case" i18n="@@seeCheckUps">See Check-ups</span>
            <span *ngSwitchCase="'week2p1-card2-cta'" i18n="@@knowMore">Know More</span>
            <span *ngSwitchCase="'week2p1-card3-cta'" i18n="@@seeUserStories">See User Stories</span>
            <span *ngSwitchCase="'week2p1-card4-cta'" i18n="@@takeHelp">Take help</span>

            <!-- Week 2 Part 2 CTA Content -->
            <span *ngSwitchCase="'week2p2-card1-cta'" i18n="@@clickHere">Click Here</span>
            <span *ngSwitchCase="'week2p2-card2-cta'" i18n="@@knowMore">Know More</span>
            <span *ngSwitchCase="'week2p2-card3-cta'" i18n="@@readMore">Read More</span>
            <span *ngSwitchCase="'week2p2-card4-cta'" i18n="@@takeHelp">Take help</span>

            <!-- Week 3 CTA Content -->
            <span *ngSwitchCase="'week3p1-card1-cta'" i18n="@@clickHere">Click Here</span>
            <span *ngSwitchCase="'week3p1-card2-cta'" i18n="@@seeUserStories">See User Stories</span>
            <span *ngSwitchCase="'week3p1-card3-cta'" i18n="@@takeHelp">Take help</span>

            <!-- Week 4 CTA Content -->
            <span *ngSwitchCase="'week4p1-card1-cta'" i18n="@@clickHere">Click Here</span>
            <span *ngSwitchCase="'week4p1-card2-cta'" i18n="@@knowMore">Know More</span>
            <span *ngSwitchCase="'week4p1-card3-cta'" i18n="@@checkDiet">Check diet</span>
            <span *ngSwitchCase="'week4p1-card4-cta'" i18n="@@takeHelp">Take help</span>


          </span>
            <cs-icon class="tw-h-6 tw-w-6 tw-text-teal-600 tw-font-[700] tw-mx-1" [iconName]="'chevron_right'"></cs-icon>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
